import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { StudentContext } from "Context/StudentContext";
import CustomTabs from "utilFunctions/shared/CustomTabs";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";

const StudentPerformanceTabsMain = ({ tabs }: any) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<number>(0);
  const { selectedStudent } = useContext<any>(StudentContext);
  useEffect(() => {
    const { state } = location;
    if (state && state.studentTab && state.studentTab != null) {
      setActiveTab(state.studentTab);
    }
  }, [location]);
  const handleTabChange = (index: number) => {
    setActiveTab(index);
    pushToDataLayerForGTM({
      event: "view_student_performance_tab",
      student_psid: selectedStudent?.psid,
      student_name: selectedStudent?.name,
    });
  };
  return (
    <CustomTabs
      activeTab={activeTab}
      setActiveTab={handleTabChange}
      tabs={tabs}
      className=""
    />
  );
};
export default StudentPerformanceTabsMain;
